/**
 * Performance: carrega fontes do Google Fonts dinamicamente,
 * apenas as 2 fontes que a campanha realmente usa (fontPrincipal + fontDestaques).
 * Substitui o link estático de 17 famílias no index.html.
 */

const FONT_WEIGHTS = {
  'Alegreya': '400,500,700,800,900',
  'Dosis': '300,400,500,600,700,800',
  'EB Garamond': '400,500,600,700,800',
  'Hepta Slab': '300,400,500,600,700,800,900',
  'Lato': '300,400,500,700,800,900',
  'Montserrat': '300,400,500,600,700,800,900',
  'Oswald': '400',
  'Playfair Display': '400,700,900',
  'Raleway': '300,400,500,600,700,800,900',
  'Red Hat Display': '400,500,700,900',
  'Roboto Slab': '300,400',
  'Roboto': '300,400,500,700,900',
  'Source Sans Pro': '300,400,600,700,900',
  'Titillium Web': '300,400,600,700,900',
  'Ubuntu': '400',
  'Zilla Slab': '300,400,500,600,700',
  'IBM Plex Serif': '400',
  'Open Sans': '300,400,600,700,800',
};

// Normaliza nomes que vêm do ColorPalette com capitalização diferente
const FONT_NAME_MAP = {
  'eb garamond': 'EB Garamond',
  'hepta slab': 'Hepta Slab',
  'playfair display': 'Playfair Display',
  'red hat display': 'Red Hat Display',
  'roboto slab': 'Roboto Slab',
  'source sans pro': 'Source Sans Pro',
  'titillium web': 'Titillium Web',
  'zilla slab': 'Zilla Slab',
  'ibm plex serif': 'IBM Plex Serif',
  'open sans': 'Open Sans',
};

const loadedFonts = new Set();
let currentLinkElement = null;

function normalizeFontName(name) {
  if (!name) return null;
  const lower = name.trim().toLowerCase();
  return FONT_NAME_MAP[lower] || name.trim();
}

function buildGoogleFontsUrl(fontNames) {
  const families = fontNames
    .map(name => {
      const normalized = normalizeFontName(name);
      if (!normalized) return null;
      const weights = FONT_WEIGHTS[normalized] || '400';
      const urlName = normalized.replace(/ /g, '+');
      return `${urlName}:${weights}`;
    })
    .filter(Boolean);

  if (families.length === 0) return null;
  return `https://fonts.googleapis.com/css?family=${families.join('|')}&display=swap`;
}

/**
 * Carrega as fontes da campanha dinamicamente.
 * Reutiliza ou substitui o <link> anterior se as fontes mudaram.
 * Nunito e Material Icons já são carregados no index.html (defaults).
 */
export function loadCampaignFonts(fontPrincipal, fontDestaques) {
  const fonts = [];
  const normalizedPrincipal = normalizeFontName(fontPrincipal);
  const normalizedDestaques = normalizeFontName(fontDestaques);

  // Nunito já é carregado no index.html, não precisa duplicar
  if (normalizedPrincipal && normalizedPrincipal !== 'Nunito' && !loadedFonts.has(normalizedPrincipal)) {
    fonts.push(normalizedPrincipal);
  }
  if (normalizedDestaques && normalizedDestaques !== 'Nunito' && normalizedDestaques !== normalizedPrincipal && !loadedFonts.has(normalizedDestaques)) {
    fonts.push(normalizedDestaques);
  }

  if (fonts.length === 0) return;

  const url = buildGoogleFontsUrl(fonts);
  if (!url) return;

  // Evita duplicar se já existe link com esta URL
  if (document.querySelector(`link[href="${url}"]`)) {
    fonts.forEach(f => loadedFonts.add(f));
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);

  fonts.forEach(f => loadedFonts.add(f));
}
